import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getQA } from "../../../features/slices/courseDetails";
import { useSelector } from "react-redux";
import AddQA from "./AddQA";
import adminPic from "../../../assets/images/admin.png";
const initailState = {
  addQAModal: false,
  QAData: {},
};
const QA = ({ courseId }) => {
  const [iState, setUpdateState] = useState(initailState);
  const { addQAModal, QAData } = iState;
  const dispatch = useDispatch();
  const { QA, loading } = useSelector((state) => state?.courseDetails);
  useEffect(() => {
    dispatch(getQA({ courseId }));
  }, []);

  const handleShowAddQA = (data) => {
    setUpdateState((prev) => ({
      ...prev,
      addQAModal: true,
      QAData: data,
    }));
  };
  const handleCloseAddQA = () => {
    setUpdateState((prev) => ({
      ...prev,
      addQAModal: false,
    }));
  };

  return (
    <>
      {QA?.result?.length > 0 ? (
        <div className="tab-pane fade active show" id="QuesAns">
          <div className="QuesAnsBody">
            <div className="StaticArea">
              <div id="accordion">
                {QA?.result?.map((res, i) => {
                  return (
                    <div className="card" key={res?._id}>
                      <div
                        className="card-header"
                        data-toggle="collapse"
                        data-parent="#accordion"
                        href={`#collapse${i}`}
                      >
                        <h4>{res?.question}</h4>
                        <aside>
                          <figure>
                            <img src={res?.userData?.profilePic || adminPic} />
                            <figcaption>
                              <h6>{res?.userData?.fullName}</h6>
                            </figcaption>
                          </figure>
                          <div className="d-flex align-items-center gap-2">
                            <p
                              className={
                                res?.status == "ANSWERD" ? "" : "unAnsweredQues"
                              }
                            ></p>
                            <a
                              className="Button"
                              onClick={() => handleShowAddQA(res)}
                            >
                              {res?.status == "ANSWERD" ? "Edit" : "Add"} answer
                            </a>
                          </div>
                        </aside>
                      </div>
                      <div
                        id={`collapse${i}`}
                        className="panel-collapse collapse in"
                      >
                        <div className="card-body">
                          <p>{res?.answer}</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <p className="d-flex justify-content-center mt-5">There is no QA !!</p>
      )}
      {addQAModal && (
        <AddQA
          handleCloseAddQA={handleCloseAddQA}
          QAData={QAData}
          courseId={courseId}
        />
      )}
    </>
  );
};

export default QA;
